module.exports = __webpack_public_path__ + "static/Forager9-2b0e2c6882f3251a4825c728c28a37d6.webp";